import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { smoothScrollToElement } from '../scroll';

class Component extends BaseComponent {
    openClass = 'accordion-open';

    constructor(props) {
        super(props);

        const attrs = {
            // cleaned up html attributes, without any weird extra junk
            ...props,
            class: props.class ? props.class.replace(this.openClass, '').trim() : '',
            // openClass added as needed
        };
        delete attrs.children;
        delete attrs.hash;
        delete attrs.innerHTML;
        delete attrs.routeTo;

        const openedByDefault = (new RegExp('\\b' + this.openClass + '\\b')).test(props.class);
        const openedByHash = props.id && props.hash == props.id;
        this.setState({
            attrs,
            isOpen: openedByHash || openedByDefault,
        });
    }

    render({ innerHTML, hash }, { attrs, isOpen }) {
        if (!isOpen) {
            isOpen = hash == attrs.id;
        }

        return (
            <div
              {...attrs}
              class={(attrs.class + (isOpen ? ` ${this.openClass}` : '')).trim()}
              dangerouslySetInnerHTML={{__html: innerHTML || ''}}
              onClick={this.click}
              ref={(el) => this.el = el}
            />
        );
    }

    click = () => {
        const opening = !this.state.isOpen;

        if (this.state.attrs.id) {
            this.props.routeTo(opening ? this.state.attrs.id : '');
        }

        if (opening) {
            smoothScrollToElement(this.el);
        }

        this.setState({ isOpen: opening });
    }

    static mapStateToProps = (state) => ({
        hash: state.route,
    })

    static mapDispatchToProps = (dispatch) => ({
        routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
    });
}

export default connect(Component.mapStateToProps, Component.mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/page-accordion.js